import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("d2-container", {
    staticClass: "release"
  }, [_c("div", {
    staticClass: "main clearfix"
  }, [_c("div", {
    staticClass: "release-right"
  }, [_c("div", {
    staticClass: "intro-form",
    attrs: {
      id: "left-menu5"
    }
  }, [_c("div", {
    staticClass: "form-head-title"
  }, [_vm._v("视频")]), _c("div", {
    staticClass: "photo",
    staticStyle: {
      margin: "15px 0"
    }
  }, [_c("div", {
    staticClass: "wlc-video-action"
  }, [_c("wlc-upload-video", {
    attrs: {
      url: _vm.form.video
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "video", $event);
      }
    }
  }), _vm.form.video ? _c("div", {
    staticClass: "icon-group"
  }, [_c("i", {
    staticClass: "fa fa-file-photo-o",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        _vm.videoVisible = true;
      }
    }
  }), _c("i", {
    staticClass: "fa fa-close",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        _vm.form.video = "";
      }
    }
  })]) : _vm._e()], 1), _vm.form.video ? _c("div", {
    staticClass: "wlc-video-cover"
  }, [_c("span", [_vm._v("封面")]), _c("wlc-image", {
    attrs: {
      src: _vm.form.cover,
      width: "120",
      height: "120",
      compression: false
    }
  })], 1) : _vm._e()])]), _c("div", {
    staticClass: "intro-form",
    attrs: {
      id: "left-menu5"
    }
  }, [_c("div", {
    staticClass: "form-head-title",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v(" 图片 ")]), _c("div", {
    staticClass: "photo"
  }, [_c("div", {
    staticClass: "photo-list clearfix"
  }, [_vm._l(_vm.form.imgs, function (img, index) {
    return _c("div", {
      directives: [{
        name: "dragging",
        rawName: "v-dragging",
        value: {
          item: img,
          list: _vm.form.imgs,
          group: "img"
        },
        expression: "{\n                                    item: img,\n                                    list: form.imgs,\n                                    group: 'img',\n                                }"
      }],
      key: index,
      staticClass: "photo-item",
      style: {
        "background-image": "url(" + img + "?imageView2/0/w/400/h/400)"
      },
      on: {
        click: function click($event) {
          _vm.form.cover = img;
        }
      }
    }, [img == _vm.form.cover ? _c("img", {
      attrs: {
        src: "".concat(_vm.$baseUrl, "image/icon-cover.png"),
        width: "50px"
      }
    }) : _vm._e(), _c("i", {
      staticClass: "iconfont fa fa-close",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.delImg(index, img);
        }
      }
    }), _c("i", {
      staticClass: "fa fa-repeat",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.selectRotateImg(index);
        }
      }
    })]);
  }), _c("wlc-upload-image", {
    attrs: {
      url: _vm.form.url,
      visible: false
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "url", $event);
      }
    }
  })], 2)])]), _c("div", {
    staticClass: "rent-form"
  }, [_c("div", {
    staticClass: "form-item clearfix"
  }, [_c("div", {
    staticClass: "form-item-label"
  }, [_vm._v("标题")]), _c("div", {
    staticClass: "form-item-value"
  }, [_c("el-input", {
    attrs: {
      type: "text",
      placeholder: "标题"
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  })], 1)]), _c("div", {
    staticClass: "form-item clearfix"
  }, [_c("div", {
    staticClass: "form-item-label"
  }, [_vm._v("分类")]), _c("div", {
    staticClass: "form-item-value"
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.categoryId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "categoryId", $$v);
      },
      expression: "form.categoryId"
    }
  }, _vm._l(_vm.categoryList, function (item, index) {
    return _c("el-radio", {
      key: index,
      attrs: {
        border: "",
        label: item.id
      }
    }, [_vm._v(_vm._s(item.chName))]);
  }), 1)], 1)]), _c("div", {
    staticClass: "form-item clearfix"
  }, [_c("div", {
    staticClass: "form-item-label"
  }, [_vm._v("描述")]), _c("div", {
    staticClass: "form-item-value"
  }, [_c("textarea", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.content,
      expression: "form.content"
    }],
    attrs: {
      placeholder: "个人说明"
    },
    domProps: {
      value: _vm.form.content
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "content", $event.target.value);
      }
    }
  })])])]), _c("div", {
    staticClass: "rent-form"
  }, [_c("div", {
    staticClass: "form-item clearfix"
  }, [_c("div", {
    staticClass: "form-item-label"
  }, [_vm._v("原价")]), _c("div", {
    staticClass: "form-item-value"
  }, [_c("el-input", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      type: "number",
      placeholder: "原价"
    },
    model: {
      value: _vm.form.originalPrice,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "originalPrice", $$v);
      },
      expression: "form.originalPrice"
    }
  })], 1)]), _c("div", {
    staticClass: "form-item clearfix"
  }, [_c("div", {
    staticClass: "form-item-label"
  }, [_vm._v("限价")]), _c("div", {
    staticClass: "form-item-value"
  }, [_c("el-input", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      type: "number",
      placeholder: "原价"
    },
    model: {
      value: _vm.form.presentPrice,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "presentPrice", $$v);
      },
      expression: "form.presentPrice"
    }
  })], 1)])]), _c("div", {
    staticClass: "intro-form"
  }, [_c("div", {
    staticClass: "form-item clearfix"
  }, [_c("div", {
    staticClass: "form-item-label"
  }, [_vm._v("城市")]), _c("div", {
    staticClass: "form-item-value"
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.cityId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cityId", $$v);
      },
      expression: "form.cityId"
    }
  }, _vm._l(_vm.cityList, function (item, index) {
    return _c("el-radio", {
      key: index,
      attrs: {
        border: "",
        label: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)]), _c("div", {
    staticClass: "form-item clearfix"
  }, [_c("div", {
    staticClass: "form-item-label"
  }, [_vm._v("区域")]), _c("div", {
    staticClass: "form-item-value"
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.districtId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "districtId", $$v);
      },
      expression: "form.districtId"
    }
  }, _vm._l(_vm.districtList, function (item, index) {
    return _c("el-radio", {
      key: index,
      attrs: {
        border: "",
        label: item.id
      }
    }, [_vm._v(_vm._s(item.chDistrictName))]);
  }), 1)], 1)])]), _c("div", {
    staticClass: "release-btn"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("保存")])], 1)])]), _c("el-dialog", {
    attrs: {
      title: "选择封面",
      visible: _vm.videoVisible,
      width: "90%"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.videoVisible = $event;
      }
    }
  }, [_c("video", {
    staticStyle: {
      width: "100%",
      height: "600px"
    },
    attrs: {
      src: _vm.form.video,
      controls: "controls",
      id: "J_video"
    }
  }, [_vm._v(" 您的浏览器不支持 video 标签。 ")]), _c("div", {
    staticStyle: {
      "text-align": "center",
      margin: "20px 0"
    }
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.videoVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.selectVideoPreview
    }
  }, [_vm._v("确 定")])], 1)])], 1), _vm.imageRotateDialogVisible ? _c("wlc-image-rotate", {
    attrs: {
      url: _vm.imageRotateUrl
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };